export const InsurersEnum = {
  unimed: 'unimed',
  portoseguro: 'portoseguro',
  others: 'outros',
};

export default {
  InsurersEnum,
};
